import React from 'react';
import { Award, Truck, ShieldCheck, Heart, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  return (
    <main className="bg-[#FAF7F2]">
      {/* Hero */}
      <section className="bg-[#1F2A44] text-[#FAF7F2] py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <span className="text-[#E8B530] uppercase text-xs tracking-[0.3em] font-semibold">About FOSEN</span>
          <h1 className="font-serif text-4xl md:text-6xl font-bold mt-4 leading-tight">Making Homes Beautiful</h1>
          <p className="mt-5 text-[#FAF7F2]/80 max-w-2xl mx-auto leading-relaxed">
            FOSEN is a premium furniture brand crafting timeless designs for modern Indian homes — from sofa sets to beds, dining and storage. Made in India, delivered to your door.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-6">
          {[
            { Icon: Award, t: 'Premium Quality', d: 'Solid wood, real leather, performance fabrics.' },
            { Icon: Truck, t: 'Pan-India Delivery', d: 'Fast 7-day delivery across major cities.' },
            { Icon: ShieldCheck, t: '5-Year Warranty', d: 'Lifetime termite warranty on solid wood.' },
            { Icon: Heart, t: 'Crafted with Love', d: 'Designed in India by master craftsmen.' },
          ].map((v, i) => (
            <div key={i} className="bg-white border border-[#1F2A44]/10 p-7 hover:border-[#E8B530] hover:-translate-y-1 transition-all duration-300">
              <div className="w-12 h-12 rounded-full bg-[#E8B530]/15 flex items-center justify-center text-[#1F2A44] mb-4">
                <v.Icon size={22} />
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1F2A44]">{v.t}</h3>
              <p className="text-sm text-[#1F2A44]/70 mt-2 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Story */}
      <section className="max-w-5xl mx-auto px-4 py-12 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1F2A44]">Our Story</h2>
        <span className="inline-block mt-3 h-[2px] w-16 bg-[#E8B530]"></span>
        <p className="mt-6 text-[#1F2A44]/80 leading-relaxed">
          We started FOSEN with a simple belief: every home deserves furniture that's beautiful, sturdy, and honestly priced. By going factory-direct and skipping middlemen, we deliver premium designs at wholesale-like pricing. Today, thousands of families trust us to make their houses feel like home.
        </p>
      </section>

      {/* Contact */}
      <section className="bg-[#F3EFE8] py-16 mt-12">
        <div className="max-w-5xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1F2A44]">Get in Touch</h2>
            <span className="inline-block mt-3 h-[2px] w-16 bg-[#E8B530]"></span>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {[
              { Icon: Phone, t: 'Call Us', v: '+91 88618 41594' },
              { Icon: Mail, t: 'Email', v: 'hello@fosen.com' },
              { Icon: MapPin, t: 'Showrooms', v: 'Across Bengaluru' },
            ].map((c, i) => (
              <div key={i} className="bg-[#FAF7F2] border border-[#1F2A44]/10 p-7 text-center hover:border-[#E8B530] transition-colors">
                <c.Icon className="text-[#E8B530] mx-auto" size={26} />
                <h3 className="font-semibold text-[#1F2A44] mt-3">{c.t}</h3>
                <p className="text-sm text-[#1F2A44]/70 mt-1">{c.v}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <Link to="/shop" className="inline-block bg-[#1F2A44] hover:bg-[#2F3B58] text-[#FAF7F2] px-8 py-3.5 uppercase tracking-wider text-sm font-semibold transition-colors">Shop Now</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
